import { Injectable } from '@angular/core';
import { QueryConfig, QueryEntity } from '@datorama/akita';
import { AppointmenteStore, AppointmentState } from './appointment.store';
import { ascSort, sortByCreatedAt } from '@ep-om/utils/sort';

@Injectable({ providedIn: 'root' })
@QueryConfig({
  sortBy: (a: { createdAt: string }, b: { createdAt: string }) => sortByCreatedAt(a, b)(ascSort)
})
export class AppointmentQuery extends QueryEntity<AppointmentState> {
  constructor(protected store: AppointmenteStore) {
    super(store);
  }

  selectAppointmentsByDate$(startDate: Date, endDate: Date) {
    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateTime = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999);
    return this.selectAll({
      filterBy: (appointment) => {
        const appointmentDate = new Date(appointment.start);
        return appointmentDate >= startDateOnly && appointmentDate <= endDateTime;
      }
    });
  }

  selectAppointmentsByIssueId$(issueId: string) {
    return this.selectAll({
      filterBy: (appointment) => appointment.issueId === issueId
    });
  }

  getAppointmentsByIssueId(issueId: string) {
    return this.getAll({
      filterBy: (appointment) => appointment.issueId === issueId
    });
  }

  getAppointmentsByUserId(userId: string) {
    return this.getAll({
      filterBy: (appointment) => appointment.userId === userId
    });
  }

  getAppointmentsByDate(startDate: Date, endDate: Date) {
    const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
    const endDateTime = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), 23, 59, 59, 999);
    return this.getAll({
      filterBy: (appointment) => {
        const appointmentDate = new Date(appointment.start);
        return appointmentDate >= startDateOnly && appointmentDate <= endDateTime;
      }
    });
  }
}
